<template>
    <div
        class="min-h-screen flex flex-col justify-center items-center py-6 px-4 bg-allday-yellow-100 bg-cover space-y-6 bg-fixed bg-left lg:bg-[image:var(--background-image-url)]"
        :style="style"
    >
        <div class="flex items-center justify-center">
            <slot name="logo" />
        </div>
        <div class="w-full sm:max-w-lg" v-if="slots.afterLogo">
            <slot name="afterLogo" />
        </div>
        <div
            class="w-full sm:max-w-lg p-8 bg-[#024643] shadow-2xl overflow-hidden rounded-3xl"
        >
            <slot />
        </div>
        <slot name="footer" />
    </div>
</template>
<script setup>
import useToast from "@/Composables/useToast";
import { usePage } from "@inertiajs/vue3";
import { useSlots, watch } from "vue";
import { computed, onMounted, reactive } from "vue";

const style = reactive({
    "--background-image-url": `url(${Vapor.asset(
        "images/guest-background.png"
    )})`,
});

const {info: infoToast, error: errorToast} = useToast()
const toastMessage = computed(() => usePage().props.flash?.message)
const toastError = computed(() => usePage().props.flash?.error)
const slots = useSlots()

watch(() => usePage().props.flash, (flash) => {
	if(flash?.message) {
		infoToast(flash.message)
	} else if(flash?.error) {
		errorToast(flash.error)
	}
})

onMounted(() => {
	if(toastMessage.value) {
		infoToast(toastMessage.value)
	}
	if(toastError.value) {
		errorToast(toastError.value)
	}
})

</script>
